/* eslint-disable */
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Analytics<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  event = (
    data: { type: string; path?: string; label?: string; detail?: string; source?: string; medium?: string; campaign?: string; sessionId: string },
    params: RequestParams = {},
  ) =>
    this.request<any, any>({
      path: `/Analytics/Event`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });
}
